
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Ky mjet ju lejon të korrigjoni listën e përbërësve. Mund të shtoni, hiqni ose modifikoni
                listën e përbërësve.
                <br>
                Ky karakter <span class="highlight">␣</span> përfaqëson një hapësirë.
                <br>
                Ky karakter <span class="highlight">↩︎</span> përfaqëson një ndërprerje rreshti. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `Duke ngarkuar vetitë...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Na ndihmoni me përbërësit`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Validoni të korrat`,
's03e9c8114521b998': `Do t'i modifikoj përbërësit`,
's05ec315d9308091a': `Ikona e cepave të barkodit`,
's061eb5af92512c85': `U ruajt! A mund të më ndihmosh me një tjetër?`,
's06847c221c4c0bc1': `Do të doja të krijoja një veti për të [përshkruani rastin tuaj të përdorimit]...`,
's06f6c6f99db6b552': `Origjinale`,
's081e2ad82db71e1d': `Vlerat e grupuara`,
's09205907b5b56cda': `Jo`,
's0b4235aae602a950': `dokumentacion i dedikuar`,
's0bb2d48532acc455': `Shkarko CSV-në`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Pavlefshmëri imazhi`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Anulo prerjen`,
's11a18a69b30b65ed': `Na ndihmoni të rregullojmë gabimet në listën e përbërësve`,
's1205d5f6fccf8e69': `Vlera e Pronës`,
's15d64a0a6715285a': `Çelës i ri`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Zona e përzgjedhjes`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Na ndihmoni të korrigjojmë informacionin ushqyes`,
's1e00019dc454872d': `Ju lutemi jepni një emër prone duke përdorur atributin property-name.`,
's1e49126af0935a5b': `Lista e produkteve që përdorin këtë pronë`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Dokumentoni pronën`,
's300b3a6ee4e1252d': str`Përputhje e dobët ${0}%`,
's33f786bb6b4f0cf4': `Rezultati i të korrave`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Pyete komunitetin së pari`,
's36d86adc823cbfa6': `Para se të krijoni një pronë të re, diskutojeni atë me komunitetin:`,
's3781d25aa51a736c': `Dokumentacioni i Motorit Folksonomy`,
's383ae4449428b61e': `Rivendos të korrat`,
's39bcf88721a1e8ee': `Rivendos përzgjedhjen`,
's39e14e14300694c7': `Dokumentacioni dhe Udhëzimet`,
's3b430cfa5c1fe7f4': str`Dokumentacioni për ${0}`,
's3f4e4b52f230a892': `Kanavacë imazhi`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Imazh qendror`,
's42dd66b2441566fd': `Ikona qendrore`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Ndrysho madhësinë djathtas`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Numri i produkteve`,
's4df2f533c0c1e7d0': `Kontrollet e imazhit`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Zhvendos përzgjedhjen`,
's4f751fb9b3ed766c': `Krijimi i një Prone të Re`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Fut emrin e pronës...`,
's55d7249883a98ca1': `rreth kësaj prone në wiki-n e Open Food Facts`,
's565867d84c04aea2': `Vetitë e filtrit...`,
's5666afe5cd0166de': `Ju lutemi korrigjoni gabimet ose modifikoni tekstin përpara se të konfirmoni`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Duke ngarkuar produktet...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Na ndihmoni të korrigjojmë informacionin ushqyes.`,
's5dd6f12783fca34f': `Redakto listën e përbërësve`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Imazh i prerë`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Përputhje e mirë ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Dokumentacioni`,
's787dd11bed0dc88a': `Ndrysho madhësinë majtas`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Mësoni më shumë rreth krijimit të pronës dhe udhëzimeve:`,
's8038273de2cf8b73': `Ju lutem zgjidhni një rajon për të prerë.`,
's839cc2908a5387f2': `Filtro barkodet...`,
's86197dcf3e96af64': `Shfletoni dhe kërkoni pronat ekzistuese`,
's8a63be30a129a59c': `Ndrysho madhësinë e pjesës së poshtme`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Ndrysho madhësinë lart djathtas`,
's8db84aa4bc949af2': `Dokumentoni Pronën e Re`,
's8f839a03997a16d7': `Shiko Produktin`,
's901ae1e236ac45d3': `Anulo fshirjen`,
's907f7a97c6b29425': `Kini kujdes që modeli i të dhënave mund të modifikohet. Përdoreni me rrezikun tuaj.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Përbërësit:`,
's9a7f60fce090ecaf': `Ngarkimi i vetive dështoi. Ju lutemi provoni përsëri më vonë.`,
's9b87abd68fb9df45': `Nuk u gjet? Krijo çelës të ri {value}`,
's9c0f52425fd2f07e': `Mund të mos përputhet`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Nuk ka rezultat të disponueshëm`,
'sa548778b24054030': `Eksploroni të gjitha vetitë e kontribuara nga projekti Folksonomy Engine. Këto veti ofrojnë meta të dhëna dhe njohuri shtesë rreth produkteve në bazën e të dhënave Open Food Facts.`,
'sa63907958bd0ec4b': `Ndrysho madhësinë lart majtas`,
'sa95b4224f685a36a': `Modali i mbyllur`,
'sab56a1d439576fd6': `Ikona e sugjerimit`,
'sac47ea2901d04c15': `Ndrysho madhësinë poshtë majtas`,
'sb125227d436c2925': `Kërkoni konceptin e pronës suaj në bazën e të dhënave ekzistuese të pronave:`,
'sb125568d43642e6f': `Përgjigjuni pyetjeve në lidhje me produktin.`,
'sb1c538e038f9b214': str`Përputhje shumë e mirë ${0}%`,
'sb28639570ff3b852': `lista e të gjitha pronave`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Pasi të keni verifikuar që prona juaj nuk ekziston dhe komuniteti të bjerë dakord që është e dobishme, së pari duhet ta dokumentoni atë në wiki.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Nuk u gjetën produkte për këtë pronë.`,
'sb7f72e4c8a2d3357': `Filtro vlerat...`,
'sb8178320160f84ea': `Shfaq prerjen`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Të gjitha pyetjet janë përgjigjur! Faleminderit për ndihmën tuaj!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Vlera Përkatëse`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Ndrysho madhësinë e pjesës së sipërme`,
'sc1c08d0cbcc3bd24': `Nuk përputhet`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Zgjidhje e sugjeruar`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Zhvendos imazhin`,
'sc895972c88d38ca5': `Vetia e Folksonomisë`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Rreshtat`,
'scb3b0671d7b7f640': `Vlerë e re`,
'scb489a1a173ac3f0': `Po `,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Bashkohuni me diskutimin në Slack`,
'scdb6cad0b92721bf': `Nuk u gjetën veti.`,
'scf23a05631f93732': `Konfirmo fshirjen`,
'scfed2f270ef6a3aa': `Zgjidh zonën`,
'sd1022bc1ef9204f7': `Imazh i zmadhueshëm`,
'sd1077c055cf9ba6b': `Na ndihmoni të vërtetojmë listën e përbërësve të produktit.`,
'sd698d21ddecba56b': `Hej! Mund të na ndihmosh të përmirësojmë informacionin e produktit duke iu përgjigjur pjesëve të mëposhtme:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Kontrolloni nëse një pronë ekziston tashmë`,
'sdbf806fefc584115': `Duhet të gjesh një`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Na ndihmoni të korrigjojmë drejtshkrimin e përbërësve.`,
'sdca5deead576ceee': `Ndrysho madhësinë poshtë djathtas`,
'sdcc2555c5dde524f': `Je i sigurt që dëshiron ta fshish këtë artikull? Ky veprim nuk mund të zhbëhet.`,
'se206feec7ec57b28': `për 100 g`,
'se419a9ab36987490': `Pavlefshmëri`,
'se5127cf0f92e7e48': `Këshillë: mund të gjeni edhe`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Do të propozoj një korrje më të mirë`,
'seea3800e27baa686': `Produkte individuale`,
'sefaba4adc4ec9219': `Vetitë e Folksonomisë`,
'seffa8ca49175b5f0': `Veti të personalizuara`,
'sf44a6b3b232c28ea': str`Zëvendësoni vlerën aktuale me ${0}`,
'sf4cd86a2f5ef2588': `Barkodi i Produktit`,
'sf57a61152168cc81': `Na ndihmoni të korrigjojmë zbulimin e përbërësve`,
'sf88b90b8ba23871c': `Përputhje e panjohur`,
'sf9aee319a006c9b4': `Shto`,
'sfacbbe968fa7d773': `Emri i pronës:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Vlera përkatëse`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  